import React from 'react';

import { Popover } from '@lyearn/ui';

import FilterList from './FilterList';
import { FilterProps } from './types';

const CLASSES = {
  button: { root: 'rounded-full justify-center items-center xs:h-32 xs:me-8' },
};

/**
 * open is used from Popover so that state is reset when popover is closed
 * if open is not used, filter state is initialized with empty array ([]) since fetching true
 */
const Filter: React.FC<React.PropsWithChildren<FilterProps>> = (props) => {
  const { children, open, onToggle, classes = CLASSES } = props;

  return (
    <Popover open={open} onOpenChange={onToggle}>
      {({ open }) => (
        <>
          <Popover.Button classes={classes.button}>{children}</Popover.Button>
          {open ? <FilterList {...props} /> : null}
        </>
      )}
    </Popover>
  );
};

export default Filter;
